import React, {Component} from 'react';
import { Auth } from 'aws-amplify'
import { toAbsoluteUrl } from "../../../_metronic";
import Tooltip from '@material-ui/core/Tooltip';


// import React from 'react';
import jsPDF from 'jspdf'
import 'jspdf-autotable'

const formatterPeso = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2
});

function obtenerFecha(){
    var getfecha = new Date();
    return getfecha.getFullYear()+'-'+('0' + (getfecha.getMonth()+1)).slice(-2)+'-'+('0' + (getfecha.getDate())).slice(-2) + ' '+ ('0' + (getfecha.getHours())).slice(-2) +':'+('0' + (getfecha.getMinutes())).slice(-2)+':'+('0' + (getfecha.getSeconds())).slice(-2);  
}

export default class ComplementoPagoPDF extends Component {

    constructor(props) {
        super(props);    
        this.state = {
            items: [],          
            isLoadedPDF: false
        };
        this.handleClick = this.handleClick.bind(this);
    }  

    async handleClick(event){
        let strEmail = null
        try{
            strEmail = await Auth.currentUserInfo();  
            strEmail  = strEmail.attributes.email;
            console.log(strEmail);
        }catch(e){
            console.log('Error');
        }

        let fechaAlta = obtenerFecha();

        var url = 'https://phkw4bym42.execute-api.us-east-2.amazonaws.com/produccion/complementospago/complementopagopdf';
        var data = {
            "strEmail": strEmail,      
            "datFechaAlta": fechaAlta,
            "dblCobranzaTimbradoSAT": this.props.dblCobranzaTimbradoSAT
        };



        console.log(data);
        fetch(url, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers:{
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => { 
            console.log(data);
            this.setState({ 
                items: data[0][0],                
                isLoadedPDF: true          
            })       
            this.generatePDF();   
        });

        
        
    }

    
    

    generatePDF = () => {
        const unit = "pt";
        const size = "A1"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape
    
        const marginLeft = 40;
        const marginBottom = 90;
        const doc = new jsPDF(orientation, unit, size);        
        
        // LOGO
    
        let contentLogo = {
          styles: {overflow: 'linebreak',  font: 'arial', fontSize: 10, cellPadding: 25, overflowColumns: 'linebreak'},
          tableWidth: 'auto',
          margin: {right:0,left:0,top:0},                       
          body: [['']],      
          columnStyles: {
            0: { fillColor: [60, 60, 60]},
          },
          
        };    
        doc.autoTable(contentLogo);
        var imgData = 'data:image/jpeg;base64,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';
        doc.addImage(imgData, 'JPEG', marginLeft, 0, 150, 70);
        //  DATOS XML                     
        const text = this.state.items.strXMLCobranza;
    

        var parser, xmlDoc;
        parser = new DOMParser();
        xmlDoc = parser.parseFromString(text,"text/xml");
        var Receptor = xmlDoc.getElementsByTagName('cfdi:Receptor');        
        var pagoCollection = xmlDoc.getElementsByTagName('pago10:Pago');
        var DocRelacionadoCollection = xmlDoc.getElementsByTagName('pago10:DoctoRelacionado');
        var ConceptosCollection = xmlDoc.getElementsByTagName('cfdi:Concepto');  
        var TimbradoCollection = xmlDoc.getElementsByTagName('tfd:TimbreFiscalDigital');
        var ComprobanteCollection = xmlDoc.getElementsByTagName('cfdi:Comprobante'); 
        var EmisorCollection = xmlDoc.getElementsByTagName('cfdi:Emisor');
        
    


        // ********************************** INFORMACION DEL EMISOR*************************** */
        doc.setFontSize(8);  
        doc.setTextColor("#52575A");        
        let strEmisorNombre = EmisorCollection[0].getAttribute('Nombre'); //Nombre Emisor
        let strDireccionEmisor = this.state.items.DireccionEmisor;
        let txtRFC = 'RFC:';
        let rfc = EmisorCollection[0].getAttribute('Rfc'); //RFC Emisor
        let widthtxtRFC = doc.getTextWidth(txtRFC);        

        let txtRegimenFiscal = 'RÉGIMEN FISCAL';
        let regimenFiscal = EmisorCollection[0].getAttribute('RegimenFiscal') + ' - '; //regimen Fiscal
        let widthTxtRegimenFiscal = doc.getTextWidth(txtRegimenFiscal);    

        let txtlugarExpedicion ='LUGAR DE EXPEDICIÓN';
        let lugarExpedicion = ComprobanteCollection[0].getAttribute('LugarExpedicion'); //Lugar de expedicion
        let widthTxtlugarExpedicion = doc.getTextWidth(txtlugarExpedicion);        

        var lMargin=40; //left margin in mm
        var rMargin=40; //right margin in mm
        var pdfInMM=330;  // width of A4 in mm
        
        doc.setFontType("bold");
        doc.text(strEmisorNombre, marginLeft, marginBottom);
        doc.setFontType("normal");
        
        var lines =doc.splitTextToSize(strDireccionEmisor, (pdfInMM-lMargin-rMargin));
	    doc.text(lMargin,marginBottom+10,lines);
        

        doc.setFontType("bold");
        doc.text(txtRFC, marginLeft, marginBottom+30);
        doc.setFontType("normal");
        doc.text(rfc, marginLeft+widthtxtRFC+5, marginBottom+30);         

        doc.setFontType("bold");
        doc.text(txtRegimenFiscal, marginLeft, marginBottom+40);
        doc.setFontType("normal");
        doc.text(regimenFiscal, marginLeft+widthTxtRegimenFiscal+5, marginBottom+40);         

        doc.setFontType("bold");
        doc.text(txtlugarExpedicion, marginLeft, marginBottom+50);
        doc.setFontType("normal");
        doc.text(lugarExpedicion, marginLeft+widthTxtlugarExpedicion+5, marginBottom+50);     
        
        /********************* COMPLEMENTO PARA RECEPCIÓN DE PAGOS ******************************/
            
        
        doc.setFontSize(8);  
        doc.setTextColor("#52575A");
            let width = doc.internal.pageSize.getWidth()

            let txtTitulo = 'COMPLEMENTO PARA RECEPCIÓN DE PAGOS';
            let widthTxtTitulo = doc.getTextWidth(txtTitulo);

            
            let txtFolio = 'FOLIO:';

            let folio = '';
            if(ComprobanteCollection[0].getAttribute('Serie') != '' ){
                folio = ComprobanteCollection[0].getAttribute('Serie') + ComprobanteCollection[0].getAttribute('Folio');
            } else {
                folio = ComprobanteCollection[0].getAttribute('Folio');
            }            
            let widthTxtFolio = doc.getTextWidth(txtFolio);
            let widthfolio = doc.getTextWidth(folio);

            let txtfechaEmision = 'FECHA Y HORA DE EMISIÓN:';
            let datfechaEmision = TimbradoCollection[0].getAttribute('FechaTimbrado'); //FechaTimbrado                  
            let txtWidthfechaEmision2 = doc.getTextWidth(txtfechaEmision);
            let txtWidthfechaEmision = doc.getTextWidth(datfechaEmision);

            let txtCertificado = "NO. CERTIFICADO EMISOR: ";
            let certificado = ComprobanteCollection[0].getAttribute('NoCertificado');  //Numero de certificado
            let widthtxtCertificado = doc.getTextWidth(txtCertificado);
            let widthCertificado = doc.getTextWidth(certificado);

            let txtComprobante = "TIPO DE COMPROBANTE: ";
            let comprobante = ComprobanteCollection[0].getAttribute('TipoDeComprobante')+" - PAGO ";  //Comprobante
            let widthtxtComprobante = doc.getTextWidth(txtComprobante);
            let widthcomprobante = doc.getTextWidth(comprobante);

            let txtVersion = "VERSIÓN: ";
            let version = "3.3";
            let widthtxtVersion = doc.getTextWidth(txtVersion);
            let widthVersion = doc.getTextWidth(version);

            let txtMoneda = "MONEDA: "; 
            let moneda = ComprobanteCollection[0].getAttribute('Moneda');  //Moneda
            let widthtxtMoneda = doc.getTextWidth(txtMoneda);
            let widthmoneda = doc.getTextWidth(moneda);
            



        doc.setFontType("bold");
        doc.text(width - Math.ceil(widthTxtTitulo)-30, marginBottom, txtTitulo);
        
        doc.setFontType("normal");
        doc.text(width - Math.ceil(widthfolio)-30, marginBottom+10, folio);           
        doc.setFontType("bold");
        doc.text(width - Math.ceil(widthfolio+5+widthTxtFolio)-30, marginBottom+10, txtFolio);                                                     

        doc.setFontType("normal");
        doc.text(width - Math.ceil(txtWidthfechaEmision)-30, marginBottom+20, datfechaEmision);   
        doc.setFontType("bold");
        doc.text(width - Math.ceil(txtWidthfechaEmision+5+txtWidthfechaEmision2)-30, marginBottom+20, txtfechaEmision);

        doc.setFontType("normal");
        doc.text(width - Math.ceil(widthCertificado)-30, marginBottom+30, certificado);   
        doc.setFontType("bold");
        doc.text(width - Math.ceil(widthCertificado+5+widthtxtCertificado)-30, marginBottom+30, txtCertificado);

        doc.setFontType("normal");
        doc.text(width - Math.ceil(widthcomprobante)-30, marginBottom+40, comprobante);   
        doc.setFontType("bold");
        doc.text(width - Math.ceil(widthtxtComprobante+5+widthcomprobante)-30, marginBottom+40, txtComprobante);

        doc.setFontType("normal");
        doc.text(width - Math.ceil(widthVersion)-30, marginBottom+50, version);   
        doc.setFontType("bold");
        doc.text(width - Math.ceil(widthtxtVersion+5+widthVersion)-30, marginBottom+50, txtVersion);

        doc.setFontType("normal");
        doc.text(width - Math.ceil(widthmoneda)-30, marginBottom+60, moneda);   
        doc.setFontType("bold");
        doc.text(width - Math.ceil(widthtxtMoneda+5+widthmoneda)-30, marginBottom+60, txtMoneda);
                            
        //Receptor
        let strReceptorNombre      = Receptor[0].getAttribute('Nombre');
        let strReceptorRFC         = Receptor[0].getAttribute('Rfc');
        let strUsoCFDI             = Receptor[0].getAttribute('UsoCFDI');
        let strResidenciaFiscal    = Receptor[0].getAttribute('ResidenciaFiscal');

        

        const headersCliente = [ [
            {
                content: 'DATOS DEL CLIENTE',
                colSpan: 4,              
            },
          ],];

        const bodyCliente= [
            ['RAZÓN SOCIAL', strReceptorNombre, 'RFC', strReceptorRFC],
            ['DOMICILIO', { content: this.state.items.DireccionReceptor, colSpan: 3 }],
        ];

        let contentCliente = {
            styles: {fontSize: 8, halign: 'center' },
            headStyles: {fillColor: [212, 31, 54], cellPadding: 2},    
            bodyStyles: {lineWidth: 1},
            startY: marginBottom+90,  
            tableWidth: 'auto',
            head: headersCliente,
            body: bodyCliente,
            columnStyles: {
                0: { fillColor: [244, 244, 244] },
                1: { fillColor: [255, 255, 255] },
                2: { fillColor: [244, 244, 244] },
                3: { fillColor: [255, 255, 255] },
                4: { fillColor: [244, 244, 244] },
                5: { fillColor: [255, 255, 255] },
                6: { fillColor: [255, 255, 255] },
                7: { fillColor: [255, 255, 255] },
            }       
        };
        

        doc.autoTable(contentCliente);

        // ********************* CONCEPTOS ***********************
        const headersConcepto = [
            ['CONCEPTOS','','','','',''],
            ['CLAV PROD. SER.', 'CANT', 'CLAVE UNIDAD', 'DESCRIPCIÓN', 'VALOR UNITARIO', 'IMPORTE']
        ];

        var ConceptosArray = Array.prototype.slice.call(ConceptosCollection);

        const bodyConceptos = ConceptosArray.map(elt=> [
            elt.getAttribute('ClaveProdServ'),
            elt.getAttribute('Cantidad'),
            elt.getAttribute('ClaveUnidad'),
            elt.getAttribute('Descripcion'), 
            formatterPeso.format(elt.getAttribute('ValorUnitario')),
            formatterPeso.format(elt.getAttribute('Importe'))            
        ]);

        // Suma de Totales de Conceptos en Importes
        let TotalConcepto = ConceptosArray.reduce(function(prev, current) {  
            console.log(current.getAttribute('Importe'))          
            return prev + +(parseFloat(current.getAttribute('Importe')).toFixed(2))               
        }, 0);

        const footConcepto = [['','','','','Total',formatterPeso.format(TotalConcepto) ]];

        let contentConcepto = {
            styles: {fontSize: 8, halign: 'center' },
            headStyles: {fillColor: [212, 31, 54], cellPadding: 2},  
            footStyles: {fillColor: [212, 31, 54], cellPadding: 2},     
            tableWidth: 'auto',
            head: headersConcepto,
            body: bodyConceptos,
            foot: footConcepto           

        };
              
        doc.autoTable(contentConcepto);
        
        // ******************** INFORMACIÓN DE PAGO *********************
        const headPago =[['INFORMACIÓN DE PAGO','','','',''],['FECHA PAGO','FORMA PAGO','MONEDA','MONTO','NÚMERO DE OPERACIÓN']]

        function verificador(strTipoPago){
            return strTipoPago == '' ? strTipoPago = 'Compensacion': strTipoPago;
        }

        var pagoArray = Array.prototype.slice.call(pagoCollection);
        var bodyPago = pagoArray.map(elt=> [                        
            elt.getAttribute('FechaPago'),
            elt.getAttribute('FormaDePagoP') + '- '+ verificador(this.state.items.strTipoPago),  //Debe de ir un if para el complemento
            elt.getAttribute('MonedaP'),                
            formatterPeso.format(elt.getAttribute('Monto')),            
            elt.getAttribute('NumOperacion'),                                 
        ]);    
                
        let contentPago = {
            styles: {fontSize: 8, halign: 'center' },
            headStyles: {fillColor: [212, 31, 54]},      
            tableWidth: 'auto',
            head: headPago,
            body: bodyPago           
        };
        
        doc.autoTable(contentPago);

        // ***************DOCUMENTO RELACIONADO*****************
        const headersDocRelacionado =[['DOCUMENTO RELACIONADO','','','','','','',''],
        ['Id Documento','Folio','Mon','M de Pago', 'Num Parcialidad', 'Importe Saldo Anterior', 'Importe Pagado', 'Importe Saldo Insoluto']]

        var DocRelacionadoArray = Array.prototype.slice.call(DocRelacionadoCollection);

        const bodyDocRelacionado = DocRelacionadoArray.map(elt=> [
            elt.getAttribute('IdDocumento'),
            elt.getAttribute('Folio'),
            elt.getAttribute('MonedaDR'),
            elt.getAttribute('MetodoDePagoDR'),            
            elt.getAttribute('NumParcialidad'),                        
            formatterPeso.format(elt.getAttribute('ImpSaldoAnt')),      
            formatterPeso.format(elt.getAttribute('ImpPagado')),
            formatterPeso.format(elt.getAttribute('ImpSaldoInsoluto'))            
        ]);
               
        // config tabla
        let contentDocRelacionado = {
            styles: {fontSize: 8, halign: 'center' },
            headStyles: {fillColor: [212, 31, 54], cellPadding: 2}, 
            bodyStyles : {cellPadding: 2},      
            tableWidth: 'auto',
            head: headersDocRelacionado,
            body: bodyDocRelacionado,           
        };
        
        doc.autoTable(contentDocRelacionado); 
        
        // *********************** TIMBRADO *************************        

        const headTimbrado =[            
            ['FOLIO FISCAL','NO. CERTIFICADO SAT','FECHA Y HORA DE TIMBRADO']
        ];

        let cadenaOriginalTimbre = "||"+TimbradoCollection[0].getAttribute('Version')+"|"+TimbradoCollection[0].getAttribute('UUID')+"|"+TimbradoCollection[0].getAttribute('FechaTimbrado')+"|"+TimbradoCollection[0].getAttribute('SelloCFD')+"|"+TimbradoCollection[0].getAttribute('NoCertificadoSAT')+"||";
        let strSelloCFD = TimbradoCollection[0].getAttribute('SelloCFD');
        let strSelloSAT = TimbradoCollection[0].getAttribute('SelloSAT');
        const bodyTimbrado =[
            [
                { content: TimbradoCollection[0].getAttribute('UUID'), styles: {fillColor: [255, 255, 255]} },
                { content: TimbradoCollection[0].getAttribute('NoCertificadoSAT'), styles: {fillColor: [255, 255, 255]} },
                { content: TimbradoCollection[0].getAttribute('FechaTimbrado'), styles: {fillColor: [255, 255, 255]} }  
            ],
            [{ content: 'Cadena Original del Timbre', colSpan: 3, styles: {fillColor: [212, 31, 54], textColor:[255,255,255],fontStyle: 'bold'} }],
            [{ content: cadenaOriginalTimbre, colSpan: 3, styles: {fillColor: [255, 255, 255]} }],
            [{ content: 'Sello Digital del Emisor', colSpan: 3, styles: {fillColor: [212, 31, 54], textColor:[255,255,255],fontStyle: 'bold'} }],
            [{ content: strSelloCFD, colSpan: 3, styles: {fillColor: [255, 255, 255]} }],
            [{ content: 'Sello Digital del SAT', colSpan: 3, styles: {fillColor: [212, 31, 54], textColor:[255,255,255],fontStyle: 'bold'} }],
            [{ content: strSelloSAT, colSpan: 3, styles: {fillColor: [255, 255, 255]} }],
            
        ];                    

        

        // config tabla
        let contentTimbrado = {
            styles: {fontSize: 8, halign: 'left' },
            headStyles: {fillColor: [212, 31, 54], cellPadding: 1, lineWidth: 1, fontSize: 8}, 
            bodyStyles: {lineWidth: 1,cellPadding: 3},
            startY: doc.autoTable.previous.finalY+10,            
            tableWidth: 'auto',
            head: headTimbrado,
            body: bodyTimbrado,                    
        };

        doc.autoTable(contentTimbrado);        
    
        doc.save(this.props.strSerieComplementoPago+'.pdf');
    }  


  
    

   render() {       
       
    // if (!this.state.isLoadedPDF){
    //     console.log('cargando')
    // } else {
    //     this.generatePDF();
    // }
   
        return(
            <Tooltip title="Descarga PDF">
                <button
                    id="btnPDF"
                    type="button"                
                    className={`btn btn-outline-danger btn-elevate kt-login__btn-primary `}                                                                       
                    style={{borderRadius: '20px',align: 'center', marginRight: '5px', padding:'5px'}}                                              
                    onClick={this.handleClick}
                >
                    <img
                        alt="pdf"
                        src={toAbsoluteUrl("/media/iconos/small/pdf.png")}                                    
                    />                
                </button> 
            </Tooltip>
        )
      
   }
}

// export default myApp;
